import Vue from 'vue'
import { CreatePopupManager } from './popup-manager'


function setStyle(element, styles) {
  function is_numeric(n) {
      return (n !== '' && !isNaN(parseFloat(n)) && isFinite(n))
  }
  Object.keys(styles).forEach(function(prop) {
      var unit = ''
      // add unit if the value is numeric and is one of the following
      if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
          unit = 'px'
      }
      element.style[prop] = styles[prop] + unit
  })
}

export function createPopoverPlugin () {
  const { getPopperModalInstance, removePopperModalInstance, getPoppperJsInstance, createPopperJsInstance } = new CreatePopupManager()

  function getReferencePopper () {
    const popperModalInstance = getPopperModalInstance()
    const popper = popperModalInstance.$el
    const reference = popperModalInstance.reference
    return {
      popper,
      reference,
      popperModalInstance
    }
  }

  function createPopper(poppverOptions) {
    const { popper, reference } = getReferencePopper()
    const virtualTablePopperJs = getPoppperJsInstance()
    if (virtualTablePopperJs && reference) {
      // 重置设置载体
      virtualTablePopperJs._reference = reference

      // 重置设置气泡，由于公用一个实例，且在表格销毁后实例也会被干掉，再次重新加载时，气泡载体内部计算需要依赖 x-placement产生的marginBottom 和 marginTop （popper.js -> getOuterSizes）
      popper.setAttribute('x-placement', virtualTablePopperJs._options.placement)
      setStyle(popper, { marginTop: 0 })
      virtualTablePopperJs._popper = popper

      // 更新时会重新计算
      virtualTablePopperJs.update()
    } else {
      if (!popper || !reference || popper.nodeType === 8) return
      const { poppverMergeOptions } = poppverOptions
      const { placement = 'top', offset = 0, arrowOffset = 0 } = poppverMergeOptions || {}
      const options = {
        placement,
        offset,
        arrowOffset,
        // boundariesElement: 'viewport' // 边界的位置
      }
      createPopperJsInstance(reference, popper, options)
      const virtualTablePopperJs = getPoppperJsInstance()
      virtualTablePopperJs.onCreate(_ => {
        Vue.nextTick(() => {
          virtualTablePopperJs.update()
        })
      })
    }
  }

  // 销毁popper
  function destroyPopver() {
    const virtualTablePopperJs = getPoppperJsInstance()
    if (virtualTablePopperJs) {
      virtualTablePopperJs.destroy()
    }
    const popperModalInstance = getPopperModalInstance()
    if (popperModalInstance) {
      removePopperModalInstance()
    }
  }

  // 更新位置
  function updatePoppver () {
    const virtualTablePopperJs = getPoppperJsInstance()
    virtualTablePopperJs && virtualTablePopperJs.update()
  }

  function setPoppverInstanceOptions ({poppverMergeOptions, poppverOnceMergeOptions}) {
    const popperModalInstance = getPopperModalInstance(poppverOnceMergeOptions)
    for (let prop in poppverMergeOptions) {
      if (poppverMergeOptions.hasOwnProperty(prop)) {
        popperModalInstance[prop] = poppverMergeOptions[prop]
      }
    }
  }

  function showPoppver (reference, poppverOptions) {
    setPoppverInstanceOptions(poppverOptions)
    const popperModalInstance = getPopperModalInstance()
    popperModalInstance.value = true
    popperModalInstance.reference = reference
    Vue.nextTick(() => {
      createPopper(poppverOptions)
    })
  }

  function hiddenPoppver () {
    const popperModalInstance = getPopperModalInstance()
    if (popperModalInstance) {
      popperModalInstance.value = false
      popperModalInstance.reference = null
    }
  }

  function visiblePoppver () {
    const popperModalInstance = getPopperModalInstance()
    if (popperModalInstance) {
      popperModalInstance.value = true
    }
  }

  return {
    destroyPopver,
    showPoppver,
    hiddenPoppver,
    getReferencePopper,
    setPoppverInstanceOptions,
    removePopperModalInstance,
    visiblePoppver,
    updatePoppver,
    getPoppperJsInstance
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-edit-table/popover/popover.js